export { deleteKey } from './deleteKey'
export { backspaceKey } from './backspaceKey'
export { arrowLeftKey } from './arrowLeftKey'
export { arrowRightKey } from './arrowRightKey'
export { keyPress } from './keyPress'



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/keyboardActions/index.js